import { Component, ChangeDetectionStrategy } from '@angular/core';

// Component used for changing the route without reloading the page. 
// This is used for changing the language on all components.
@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    template: ''
})
export class ReloadComponent {
}